/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { EditorLoadingSkeleton } from '@wisemapping/editor';

const isEditorRoute = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return /\/c\/maps\/(?:\d+)(?:\/|$)/.test(window.location.pathname);
};

const LoadingFallback = (): React.ReactElement => {
  if (isEditorRoute()) {
    return <EditorLoadingSkeleton />;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress size={48} />
      <Typography variant="h6" color="text.secondary">
        <FormattedMessage id="common.loading" defaultMessage="Loading..." />
      </Typography>
    </Box>
  );
};

export default LoadingFallback;
